import { useTranslation } from 'react-i18next'
import { HappyExpertsIcon2 } from 'src/components/HappyExperts/HappyExpertsIcon2'
import myCoachLogo from '../../assets/images/my-coach-logo-2.svg'

function LeftSide() {
  const { t } = useTranslation()
  const isHappyExpert = window.location.origin.includes('happyexperts')

  return (
    <div className="col-lg-6 d-none d-lg-flex justify-content-center align-items-center rounded-lg auth-h100">
      <div
        style={{ width: '100%', maxWidth: isHappyExpert ? '35rem' : '25rem' }}
      >
        {isHappyExpert ? (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '10px',
            }}
          >
            <HappyExpertsIcon2
              preserveAspectRatio="xMidYMid meet"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                maxHeight: '300px',
                objectFit: 'contain',
              }}
            />
          </div>
        ) : (
          <div className="">
            <img
              alt="my-coach-logo"
              className="bi bi-clipboard-check"
              src={myCoachLogo}
              style={{
                width: '400px',
              }}
            />
          </div>
        )}
        <div
          style={{
            width: '400px',
            height: '245px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontFamily: 'Georgia, serif',
            fontSize: '28px',
            fontStyle: 'italic',
            color: 'var(--color-primary)',
            ...(isHappyExpert && {
              paddingTop: '2rem',
              fontSize: '32px',
              alignItems: 'flex-start',
              width: '100%',
              fontStyle: 'normal',
            }),
          }}
        >
          {!isHappyExpert
            ? t('auth.leftSide.title', 'Grow & Flourish')
            : t(
                'auth.leftSide.happyExTitle',
                'Making Each Human a Happy Expert',
              )}
        </div>
      </div>
    </div>
  )
}

export default LeftSide
